export default "__VITE_ASSET__668728ca__"